<figure class="ref-dist-chart">
  <figcaption class="ref-dist-chart__title">{{ distribution.label }}</figcaption>
  <div
    echarts
    class="ref-dist-chart__canvas"
    [style.height.px]="chartHeight"
    [options]="chartOptions"
    [autoResize]="true"
  ></div>
  <p *ngIf="distribution.note" class="ref-dist-chart__note">{{ distribution.note }}</p>
  <p *ngIf="distribution.total != null && !distribution.note" class="ref-dist-chart__note">
    Total: {{ distribution.total }}
  </p>
</figure>
